import * as React from "react";
import { useSelector, RootStateOrAny } from "react-redux";
import BasicList from "../../common/layout/BasicList";

import {
    setDriver,
    setSelectedDrivers,
    toggleDriversPanel,
    reloadDrivers,
    addNewDriver,
} from "../../../config/redux/drivers/driversActions";
import { columns } from "./driversColumns"
import { getYears } from "../../../connectors/drivers/connectors/index";

const DriversList: React.FC = () => {
    const {
        selectedDrivers,
        activeDriver,
        driverPanelOpen,
        reloadDriversList,
        addDriver,
        removeDriver,
    } = useSelector((state: RootStateOrAny) => state.drivers);

    const parseDriver = (items: any) => {
        const drivers = items.items.map((item: any) => {
            return {
                key: item.id,
                id: item.id,
                isActive: item.isActive,
            };
        });
        return drivers;
    };

    return (
        <>
            <BasicList
                setSelectedItems={setSelectedDrivers}
                setActiveItem={setDriver}
                togglePanel={toggleDriversPanel}
                reload={reloadDrivers}
                editList={addNewDriver}
                getData={getYears}
                activeItem={activeDriver}
                panelOpen={driverPanelOpen}
                selectedItems={selectedDrivers}
                removeItems={removeDriver}
                reloadItems={reloadDriversList}
                listEdited={addDriver}
                columns={columns}
                parseItems={parseDriver}
            />
        </>
    );
};

export default DriversList;


